/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-icon': {
    width: 38,
    height: 41,
    viewBox: '0 0 38 41',
    data: '<defs><filter x="-7.5%" y="-14.8%" width="115%" height="131.3%" filterUnits="objectBoundingBox" id="svgicon-map-icon-a"><feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="6" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 0.529411765 0 0 0 0 0.639215686 0 0 0 0 0.694117647 0 0 0 0.3 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/><feMerge><feMergeNode in="shadowMatrixOuter1"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g transform="translate(9 5.552)" filter="url(#svgicon-map-icon-a)" _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M15 5a7.071 7.071 0 0 1 0 10l-5 5-5-5A7.071 7.071 0 1 1 15 5z" stroke-linejoin="round"/><circle pid="1" cx="10" cy="9.345" r="1.784"/></g>'
  }
})
